import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import UsageCard from "./components/UsageCard";
import styles from "./styles/Usage";
const useStyles = createUseStyles(styles, 'Usage');
const Usage = /*#__PURE__*/memo(_ref => {
  let {
    schema,
    locale = 'en',
    onHover,
    linkCallback
  } = _ref;
  const classes = useStyles();
  const cards = useMemo(() => {
    return schema !== null && schema !== void 0 && schema.length ? schema.map((card, index) => /*#__PURE__*/React.createElement(UsageCard, _extends({
      key: index,
      locale: locale,
      onHover: onHover,
      linkCallback: linkCallback
    }, card))) : [];
  }, [schema, locale, onHover, linkCallback]);
  return cards.length ? /*#__PURE__*/React.createElement("section", {
    className: classes.root
  }, cards) : null;
});
process.env.NODE_ENV !== "production" ? Usage.propTypes = {
  locale: PropTypes.string,
  onHover: PropTypes.func,
  schema: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.string,
    progress: PropTypes.shape({
      value: PropTypes.number,
      max: PropTypes.number
    }),
    progressCustomFormat: PropTypes.func,
    info: PropTypes.shape({
      text: PropTypes.string,
      cta: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.oneOf(['primary', 'secondary']),
        text: PropTypes.string,
        onClick: PropTypes.func
      }))
    })
  })).isRequired,
  linkCallback: PropTypes.func
} : void 0;
export default Usage;